import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from 'primereact/button'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { updateComEffectiveType } from '../../../utility/service/dataRegister-service'
import { SystemLoading,checkLoading } from '../../../store/loadingStore'
import { checkDpSuccess } from '../../../utility/service/tool-service'
import { MessageContext,handleSuccessMessage } from '../../../store/messageStore' 
import PrimeConfirmDialog from '../../../components/dialog/PrimeConfirmDialog'

const CusContractTable = ({contractList,isAdmin=false,updateContract}) => {
    const { t } = useTranslation();
    const [, loading] = useContext(SystemLoading);
    const [, dispatch] = useContext(MessageContext); //訊息視窗
    const [updateDialog,setUpdateDialog] = useState(false);
    const [modifyObj,setModifyObj] = useState({});

    const actionBodyTemplate = (data,props) => {
        if(props.rowIndex>0){
            return (
                // 如果有更新時間 筆disabled
                <Button
                    disabled={data?.time}
                    rounded text severity="secondary"
                    className="p-button-icon-only"
                    tooltipOptions={{ position: 'top' }}
                    tooltip={data?.status}
                    onClick={() => { modifyItem(data,props.rowIndex);
                     }}
                >
                    <FontAwesomeIcon icon="fa-solid fa-pen" />
                </Button>
            )
        }
        
    }

    const modifyItem = (item,rowIndex)=>{
        // reqType 1 簽約中 更新發票 2 付款成功 更新合約
        setModifyObj({
            ...item,
            rowIndex,
            confirmContext:rowIndex===1?t('confirm_contract'):t('confirm_invoice')
        })
        setUpdateDialog(true);
    }

        const confirmUpdate = ()=>{
            checkLoading(loading);
            updateComEffectiveType({
                companiesContractId:modifyObj?.companiesContractId,
                companySeq:modifyObj?.companySeq,
                reqType:modifyObj?.rowIndex
            })
                .then((res)=>{
                    if(checkDpSuccess(res)){
                        setUpdateDialog(false);
                        handleSuccessMessage(dispatch, t('button.update')+ t('message.success'));
                        setUpdateDialog(false);
                        updateContract();//刷新父層的清單
                    }
                }).finally((fin)=>{
                    checkLoading(loading,false);
                })
        }
  return (
    <> 
    <DataTable
        stripedRows
        className="white-data-table hover-highlight no-shadow"
        value={contractList}
        >

        <Column field="status"  header={t('status')} />
        <Column field="time"  header={t('time')} />
        <Column field="personnel" header={t('personnel')} />
        {isAdmin && <Column field="action" header={t('action')} body={actionBodyTemplate} /> }
    </DataTable> 

    {
        isAdmin && (
            <PrimeConfirmDialog
                visible={updateDialog}
                onClose={() => { setUpdateDialog(false) }}
                onConfirm={() => { confirmUpdate(); }}
                title={modifyObj?.status}
                bodyTemplate={<>
                    <label htmlFor="">
                       {modifyObj?.confirmContext}
                    </label>
                </>}
            />
        )
    } 

    </>
  )
}

export default CusContractTable